import React, { useState, useEffect } from "react";
import useVisible from "../../hooks/useVisible.jsx";
import handleClick from "../../utils/handleClick.js";

function FillPlaceholders({
  onPopupStateChange,
  selectedTag,
  buttonTag,
  generateButtonTags,
}) {
  const [isVisible, setIsVisible] = useVisible("FillPlaceholdersVisibility");

  useEffect(() => {
    if (onPopupStateChange) {
      onPopupStateChange(isVisible);
    }
  }, [isVisible]);

  if (selectedTag && selectedTag !== buttonTag) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i class="fa-regular fa-folder-image fa-fw"></i>
        </div>
        <div className="button-card__title">Fill Placeholders</div>
        {generateButtonTags()}
      </li>
      <div
        className={`render-group ${isVisible ? "" : "render-group--hidden"}`}
      >
        <div className="videobolt-tools">
          <div
            onClick={() =>
              handleClick("ppFillPlaceholders", { type: "project" })
            }
            className="resolution-tools__button"
          >
            <i class="fa-regular fa-shuffle"></i>
            <span>Random</span>
          </div>
          <div
            onClick={() =>
              handleClick("ppFillPlaceholders", { type: "selected items" })
            }
            className="resolution-tools__button"
          >
            <i class="fa-regular fa-image"></i>
            <span className="render-group__button-text">Selected Items</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default FillPlaceholders;
